// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cXSd","badges":"styles_badges__3uSSC"};